import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { toggleLoading } from 'src/app/modules/redux';
import { EntitiesForSubDocsModel, KycSignatoryForSubDocModel, SubDocsPersonModel } from '../../models/entities-for-subdoc';
import { IDealSubscription, IDealSyndication } from '../../models';
import { IEntityDTO, ISignatoryDTO, ISubdocAccessPerson } from '../../models/syndication';
import { UuidService, LookupService } from 'src/app/services';
import { DataService } from 'src/app/services/data/data.service';
import { DealService } from '../../services';
import { SubdocService } from '../../services/subdoc/subdoc.service';
import {ToastrService} from "ngx-toastr";
import { Store } from '@ngrx/store';
import { DealSignatoryAddPersonModalComponent } from '../deal-signatory-add-person-modal/deal-signatory-add-person-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { ModalSize, UtilService } from 'src/app/modules/shared/services/util/util.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-deal-signatories',
  templateUrl: './deal-signatories.component.html',
  styleUrls: ['./deal-signatories.component.scss']
})
export class DealSignatoriesComponent implements OnInit {

  @Input() syndication!: IDealSyndication | IDealSubscription;

  businessUnitEntities: EntitiesForSubDocsModel[] = [];
  selectedBusinessUnitEntity?: EntitiesForSubDocsModel;
  selectedSignatory?: KycSignatoryForSubDocModel;
  dealSignatories: SubDocsPersonModel[] = [];

  constructor(private dealService: DealService,
    private subDocService: SubdocService,
    private store: Store,
    private toastrService: ToastrService,
    private util: UtilService,
    private dialog: MatDialog,
    private uuid: UuidService,
    private dataService: DataService,
    private router: Router
  ) { }

  ngOnInit(): void {
    console.log("Deal Issuer Signatories - syndication", this.syndication);
    if (!this.syndication)
      return;

    this.getEntitiesForBusinessUnit(this.syndication.issuerBusinessUnitId);
    this.getDealSignatories();
  }

  getErrorMsg() : string {
    return this.selectedBusinessUnitEntity?.kycErrorMessage ?? '';
  }

  getDisabledMsg() : string {
    if (this.syndication == null)
      return 'n/a';

    return this.syndication.numberOfIssuerSubDocSignatories == 1 ? 'Maximum of one (1) Signatory' : 'Maximum of two (2) Signatories';
  }

  addSelectedSignatory() {
    if (!this.selectedSignatory) {
      this.toastrService.error("Please select a signatory, or add a new one!");
      return;
    }

    if (this.dealSignatories.length >= 2) {
      this.toastrService.warning("You can have a minimum of 1 and maximum of 2 signers.");
      return;
    }

    this.dialog.open(DealSignatoryAddPersonModalComponent, {
      width: this.util.getModalWidth(ModalSize.SMALL),
      data: {
        fullName: this.selectedSignatory.name,
        email: ''
      }
    })
    .afterClosed().subscribe(result => {
      if (!!result) {
        this.dealSignatories.push(<SubDocsPersonModel> {
          id: this.uuid.generateFormattedUUID(),
          businessUnitEntityKycPersonId: this.selectedSignatory?.businessUnitEntityKycAuthorizedSignatoryId,
          fullName: result.fullName,
          email: result.email,
          sortOrder: this.dealSignatories.length + 1
        });
      }
    });
  }

  addNonKYCSignatory() {
    if (this.dealSignatories.length >= 2) {
      this.toastrService.warning("You can have a minimum of 1 and maximum of 2 signers.");
      return;
    }

    this.dialog.open(DealSignatoryAddPersonModalComponent, {
      width: this.util.getModalWidth(ModalSize.SMALL),
    })
    .afterClosed().subscribe(result => {
      if (!!result) {
        this.dealSignatories.push(<SubDocsPersonModel> {
          id: this.uuid.generateFormattedUUID(),
          businessUnitEntityKycPersonId: null,
          fullName: result.fullName,
          email: result.email,
          sortOrder: 1
        });
      }
    });
  }

  
  // ISSUER SIGNATORIES START
  removeSignatory(signatory: SubDocsPersonModel) {
    this.dealSignatories = this.dealSignatories.filter(x => x.id != signatory.id);
  }

  getEntitiesForBusinessUnit(businessUnitId: string) {
    // console.log("Fetching Entities...");
    this.subDocService.getSubdocEntities(businessUnitId).subscribe({
      next: (entities: IEntityDTO[]) => {
        console.log("Fetched Entities", entities);
        this.businessUnitEntities = entities;
      }, error: err => {
        this.toastrService.error("Unable to get entities!", $localize`:@@companyName:Rondeivu`);
      }
    });
  }

  getDealSignatories() {
    // console.log("Fetching Deal Signatories...");
    this.dealService.getDealSignatories().subscribe({
      next: (signatories: SubDocsPersonModel[]) => {
        console.log("Current Signatories", signatories)
        this.dealSignatories = Object.assign(signatories);
      }, error: err => {
        this.toastrService.error("Unable to get deal signatories!", $localize`:@@companyName:Rondeivu`);
      }
    });
  }

  saveDealSignatories() {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    var emailsNotValid = this.dealSignatories.filter(x => !x.email || !emailRegex.test(x.email));

    if (emailsNotValid.length > 0) {
      this.toastrService.warning("One of emails entered for signers is empty or invalid!");
      return;
    }

    if (this.dealSignatories.length > 2) {
      this.toastrService.warning("You can have a minimum of 1 and maximum of 2 signers.");
      return;
    }

    console.log("Updating Deal Signatories...");
    this.store.dispatch(toggleLoading({loading: true}));
    this.dealService.updateDealSignatories(this.dealSignatories).subscribe({
      next: (signatories: any) => {
        this.store.dispatch(toggleLoading({loading: false}));
        this.toastrService.success("Deal Signatories Updated!", $localize`:@@companyName:Rondeivu`);
      }, error: err => {
        this.store.dispatch(toggleLoading({loading: false}));
        this.toastrService.error("Unable to update deal signatories!", $localize`:@@companyName:Rondeivu`);
      }
    });
  }

  openKyc() {
    if (!this.selectedBusinessUnitEntity) {
      this.toastrService.error("Could not resolve entity id");
      return;
    }

    var baseUrl = window.location.origin;
    var route = this.router.createUrlTree([this.dataService.getBuSlug(), 'entities', this.selectedBusinessUnitEntity.entityId, 'kyc', this.selectedBusinessUnitEntity.businessUnitEntityKycId]);
    var combinedUrl = baseUrl + route.toString();

    setTimeout(() => {
      window.open(combinedUrl, '_blank');
    }, 500);
  }

  get currentSignatoriesString() : string {
    if (this.dealSignatories.length > 0)
      return "Current Signatories " + this.dealSignatories.map(x => x.fullName).join(", ");
    else 
      return "No Signatories Set";
  }

}
